import { AuthProvider } from '@descope/react-sdk'
import AuthFlow from './components/AuthFlow';
import Navbar from './components/Navbar';
import Introduction from './components/Introduction';
import BottomNav from './components/BottomNav';
import events from './events';

import './App.css';

function App() {
  
  const theme = "dark"
  const queryParameters = new URLSearchParams(window.location.search)
  const eventCode = queryParameters.get("eventCode") || "default"
 
  const event = (events[eventCode]) ? events[eventCode] : events['default'];
  const project = event.projectId || process.env.REACT_APP_DESCOPE_PROJECT_ID

  return (
    <>
        <>
          <Navbar />
          <Introduction title={event.title} subtitle={event.subtitle} desc={event.desc}/>

          <AuthProvider projectId={project}>
            <AuthFlow 
              defaultFlow={event.flow} 
              theme={theme} 
              borderRounded = {project}
              event = {event}
            />
          </AuthProvider>
          <BottomNav />
        </>
    </>
  )
}


export default App;
